export default __webpack_public_path__ + "static/media/hht2_ep17_timeline_q04_a.6368c47f.png";